<template>
    <div
        class="mt-6 flex flex-col divide-x-0 divide-y divide-gray-500 lg:flex-row lg:divide-x lg:divide-y-0"
    >
        <slot />
    </div>
</template>
